import { DashboardSortBy, TicketPriority, useGetTicketsQuery } from "../../__generated__/api";
import { Ticket } from "./TicketsV3";

function getDateField(ticket: Ticket, field: keyof Ticket) {
    const value = ticket[field];
    if (!value) {
        return 0;
    }
    return value instanceof Date ? value.getTime() : new Date(value).getTime();
}

const PriorityOrder = {
    [TicketPriority.Critical]: 0,
    [TicketPriority.High]: 1,
    [TicketPriority.Medium]: 2,
    [TicketPriority.Low]: 3,
};

const SORT_FUNCTION: Record<DashboardSortBy, ((value: Ticket) => number) | undefined> = {
    [DashboardSortBy.CreatedDateAscending]: row => getDateField(row, "createdDate"),
    [DashboardSortBy.CreatedDateDescending]: row => -1 * getDateField(row, "createdDate"),

    [DashboardSortBy.PriorityAscending]: value => PriorityOrder[value.priority ?? TicketPriority.Medium],
    [DashboardSortBy.PriorityDescending]: value => -1 * PriorityOrder[value.priority ?? TicketPriority.Medium],

    [DashboardSortBy.LastResponseDateAscending]: row => getDateField(row, "lastResponseDate"),
    [DashboardSortBy.LastResponseDateDescending]: row => -1 * getDateField(row, "lastResponseDate"),

    [DashboardSortBy.TicketNumberAscending]: value => value.ticketNumber ?? 0,
    [DashboardSortBy.TicketNumberDescending]: value => -1 * (value.ticketNumber ?? 0),

    [DashboardSortBy.Manual]: undefined,
};

export default function sortTickets(tickets: Ticket[], sortBy: DashboardSortBy) {
    const sortHandler = SORT_FUNCTION[sortBy];

    return tickets.toSorted(sortHandler);
}
